// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WNnaj39XWN4Boyoj{border-radius:1000px}.LtAfHSG2qQEF35U5{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.ZmuhX9kP4ApAaeS4{display:flex;flex-direction:column;justify-content:center;align-items:center}.NqoIuEMxnCMONBOq{animation:k13lfAEyYfMNun7B 3s infinite;animation-iteration-count:infinite}@keyframes k13lfAEyYfMNun7B{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.hm9aY0dbPZ0ho9zX{width:230px;border-radius:4px;padding:2px;border-color:var(--py-neutral-0);transition:all .16s}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `WNnaj39XWN4Boyoj`,
	"text-truncate": `LtAfHSG2qQEF35U5`,
	"shaquille": `ZmuhX9kP4ApAaeS4`,
	"shimmer": `NqoIuEMxnCMONBOq`,
	"placeHolderShimmer": `k13lfAEyYfMNun7B`,
	"searchContainer": `hm9aY0dbPZ0ho9zX`
};
export default ___CSS_LOADER_EXPORT___;
